import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Box, Heading, MainArea, Page, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import { ClientLevel } from 'core/types';
import { ImportConfirmationModal } from '../components/ImportConfirmationModal';
import { ClientSelectionArea } from '../components/ClientSelectionArea';
import { AnalysedFileModal } from '../components/AnalysedFileModal';
import { DropFilesArea } from '../components/DropFilesArea';
import { ImportConsentProvider } from '../context/ImportConsentContext';
import { BottomBarAnalysisNav } from '../components/BottomBarNav';

export const ConsentAnalysisPage = () => {
  const { t } = useTranslation('fileManagement');
  const { clientLevel, clientId } = useParams<{ clientLevel: ClientLevel; clientId: string }>();

  return (
    <ImportConsentProvider clientId={clientId} clientLevel={clientLevel}>
      <MainArea>
        <TopArea>
          <AppTopBar />
        </TopArea>
        <Page>
          <AnalysedFileModal />
          <ImportConfirmationModal />
          <Box stackItems={true}>
            <Heading>{t('analysis.title')}</Heading>
            <ClientSelectionArea />
            <DropFilesArea />
          </Box>
        </Page>
        <BottomBarAnalysisNav />
      </MainArea>
    </ImportConsentProvider>
  );
};
